// Permission-based action component
// Automatically disables/hides actions based on user permissions

import React from 'react';
import { usePermissions } from '../contexts/PermissionContext';
import { canPerformAction } from '../utils/permissionChecker';

const PermissionAction = ({ 
  actionKey, 
  children, 
  disabled = false,
  hideIfNoPermission = false,
  fallback = null,
  ...props 
}) => {
  const { loading, hasPermission } = usePermissions();
  
  // Show loading while permissions are being loaded
  if (loading) {
    return null;
  }
  
  // Check if user can perform this action
  const canPerform = canPerformAction(actionKey, hasPermission);
  
  // Hide component if no permission and hideIfNoPermission is true
  if (!canPerform && hideIfNoPermission) {
    return fallback;
  }
  
  // If no permission, show fallback or disabled version
  if (!canPerform) {
    if (fallback) {
      return fallback;
    }
    
    // Return disabled version of the component
    return React.cloneElement(children, {
      ...props,
      disabled: true,
      className: `${props.className || ''} opacity-50 cursor-not-allowed`,
      title: 'You don\'t have permission to perform this action'
    });
  }
  
  // User has permission, render normally
  return React.cloneElement(children, {
    ...props,
    disabled: disabled
  });
};

export default PermissionAction;
